import { ITableReport,Report } from "src/Interfaces/TableInterfaces";
import TableTemplate,{ IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { tableRefreshInterval } from "../model";
interface Props<Row extends ITableReport> {
  title?: string;
  getData: (offset: number|null,pageSize: number|null) => Promise<Report<Row>>;
  onRowClick?: (row: Row) => void;
  additionalBody?: IAdditional<Row>;
  onFetchComplete?: () => void;
  refreshFlag?: boolean;
}

export const RemoteTable=<Row extends ITableReport>({ title,getData,onRowClick,additionalBody,onFetchComplete,refreshFlag }: Props<Row>) => (<div className="min-w-0 w-full max-w-full overflow-hidden">
  {title? <div className="font-semibold text-xs mb-2">{title}</div>:null}
  <TableTemplate<{},Row>
    refreshTableTime={tableRefreshInterval}
    showIsLoading={false}
    hideUntilResponse
    getDataTable={(_,offset,pageSize) => getData(offset,pageSize)}
    onFetchComplete={onFetchComplete}
    tableWrapperClassname="!mx-0 !min-w-0 !w-full !max-w-full [&>div]:!min-w-0 [&>div]:!max-w-full"
    TableUI={({ reports,onAction }) => (<CommonTableUI
      reports={reports}
      onAction={onAction}
      AdditionalBody={additionalBody}
      onTableRowClick={onRowClick}
      refreshFlag={refreshFlag}
      tableBoxClassName="!mx-0 !max-h-[500px] !w-full !max-w-full !overflow-auto [&_table]:!min-w-max"
    />)}
  />
</div>);
